import UserPage, {IUserPageAttrs} from "./UserPage";
import Mithril from "mithril";
import app from "../app";

/**
 * 草稿【个人中心】
 */
export default class DraftUserPage extends UserPage {
  oninit(vnode: Mithril.Vnode<IUserPageAttrs, this>) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }

  oncreate(vnode: Mithril.VnodeDOM<IUserPageAttrs, this>) {
    super.oncreate(vnode);
    app.drafts.load();
  }

  onremove(vnode: Mithril.VnodeDOM<IUserPageAttrs, this>) {
    super.onremove(vnode);
    if (app.cache.draftsLoaded) {
      app.cache.draftsLoaded = false;
    }
  }

  content() {
    const { DraftsList } = flarum.extensions?.['fof-drafts']?.['components'];
    if (!DraftsList) return;

    return (
      <div className="DraftUserPage">
        <DraftsList state={app.drafts}></DraftsList>
      </div>
    );
  }
}
